import { useContext, useState } from 'react'
import styled from 'styled-components'

import { emailNotes } from '../api/server-api'

//import Checkbox from '../basic-components/Checkbox'
import Container from '../basic-components/Container'
import Content from '../basic-components/Content'
import { Header } from '../basic-components/HeaderFooter'
import HeaderTitle from '../basic-components/HeaderTitle'
//import List from '../basic-components/List'
//import ListItem from '../basic-components/ListItem'
//import ListItemText from '../basic-components/ListItemText'
import Modal from '../basic-components/Modal'
import TextInput from '../basic-components/TextInput'

import ErrorDialog from './ErrorDialog'
import NoteText from './NoteText'


import PaperPlaneIcon from '../icons/PaperPlaneIcon'
import BackIcon from '../icons/BackIcon'
//import CheckIcon from '../icons/CheckIcon'
//import EnvelopeIcon from '../icons/EnvelopeIcon'
import IconContainer from '../icons/IconContainer'
//import ListIcon from '../icons/ListIcon'
//import TrashIcon from '../icons/TrashIcon'

//import ConfirmDialog from './ConfirmDialog'

import NotesContext from '../context/NotesContext'

const EmailInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 2px solid red;
`
const Label = styled.label`
  flex: none;
  display: inline-block;
  text-align: ${props => props.align ? props.align : 'right'};
  padding: 0.7rem;
  min-width: 7rem;
`
const RowContainer = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: space-evenly;
`


export default function EmailNotesPage({ onBackClick }) {
  const { notes } = useContext(NotesContext);

  const [ recipient, setRecipient ] = useState('');
  const [ sender, setSender ] = useState('');
  const [ subject, setSubject ] = useState('Notes from MapClickMobile');
  const [ messageBody, setMessageBody ] = useState('Attached are Notes from MapClickMobile.');
  const [ modalOpen, setModalOpen ] = useState(false);

  const sendClickHandler = async () => {
    //console.log(sender);
    if (!recipient) {
      //console.log('recipient is bad');
      setModalOpen(true);
      return;
    }

    const fromAddress = sender ? sender : recipient;

    const checkedNotes = [];
    Object.keys(notes).forEach((id, i) => {
      if (notes[id].checked) {
        checkedNotes.push(notes[id]);
      }
    });

    // send to server here...
    const result = await emailNotes(checkedNotes, {
      to: recipient,
      from: fromAddress,
      subject: subject,
      body: messageBody,
    });

    // TODO: check result for success
    //console.log(result);

    // return to previous page
    onBackClick();
  }

  const recipientChangeHandler = (e) => { setRecipient(e.target.value); }

  const senderChangeHandler = (e) => { setSender(e.target.value); }

  const subjectChangeHandler = (e) => { setSubject(e.target.value); }

  return (
    <>
    <Container>
      <Header>
        <IconContainer>
          <BackIcon onClick={onBackClick}/>
        </IconContainer>
        <HeaderTitle><strong>Email Notes</strong></HeaderTitle>
        <IconContainer>
          <PaperPlaneIcon onClick={sendClickHandler}/>
        </IconContainer>
      </Header>

      <Content>
        <EmailInfo>
          <RowContainer>
            <Label><strong>To: </strong></Label>
            <TextInput
              value={recipient}
              placeholder="recipient@example.com"
              onChange={recipientChangeHandler}
            />
          </RowContainer>
          <RowContainer>
            <Label><strong>From: </strong></Label>
            <TextInput
              value={sender}
              placeholder="sender@example.com"
              onChange={senderChangeHandler}
            />
          </RowContainer>
          <RowContainer>
            <Label><strong>Subject: </strong></Label>
            <TextInput
              value={subject}
              onChange={subjectChangeHandler}
            />
          </RowContainer>
          <Label align="left"><strong>Message body: </strong></Label>
          <RowContainer style={{flex: '1 0'}}>
            <NoteText
              value={messageBody}
              editing={true}
              onChange={setMessageBody}
            />
          </RowContainer>
        </EmailInfo>
      </Content>

    </Container>

    <Modal
      open={modalOpen}
      showCloseIcon={false}
      closeOnOverlayClick={false}
      onClose={() => setModalOpen(false)}
    >
      <ErrorDialog
        message="No recipient email address!"
        onClick={() => setModalOpen(false)}
      />
    </Modal>
    </>

  );
}
